import QuestionIcon from 'assets/images/question-icon.svg';
import styled, { css } from 'styled-components';
import media from 'styled-media-query';

import { ButtonProps } from './types';

const WrapperModifiers = {
  hidden: () => css`
    display: none;
  `,
};

export const Label = styled.span`
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  padding: 0 0 0 5px;
`;

export const Wrapper = styled.button<ButtonProps>`
  ${({ hidden }) => css`
    align-items: center;
    background-color: #ffbc00;
    border-radius: 50%;
    border: 1px solid #ffffff;
    border: none;
    bottom: 35px;
    box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    display: flex;
    height: 46px;
    justify-content: center;
    position: fixed;
    right: 24px;
    width: 46px;

    ${Label} {
      display: none;
    }

    ${media.greaterThan('medium')`
        height: 40px;
        width: 82px;
        border-radius: 40px;

      ${Label} {
        display: block;
      }

    `}

    ${hidden && WrapperModifiers.hidden()}
  `}
`;

export const Icon = styled.img.attrs(() => ({ src: QuestionIcon }))``;
